import React from 'react';

const IconBlog = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    role="img"
    width={24} 
    height={24}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="1"
    strokeLinecap="round"
    strokeLinejoin="round"
    className="feather feather-blog">
    <title>Blog</title>
    <path d="M5 16a3 3 0 1 0 0 6 3 3 0 0 0 0-6ZM5 1c9.925 0 18 8.075 18 18m-5 0c0-7.168-5.832-13-13-13m8 13c0-4.411-3.589-8-8-8m-3 0v8"/>
  </svg>

);

export default IconBlog;
